import styled from "@emotion/styled";
import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import React, { useRef, useState, useEffect } from "react";
import Layout from "../layout/Layout";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  updatePartners,
  singlePartners,
} from "../../../states/actions/partnersAction";
import BaseUrl from "../../../service/API/base_url";
import { useTranslation } from "react-i18next";

const UpdatePartners = () => {
  const imageInput = useRef(null);
  const [imageGallery, setImageGallery] = useState();

  const UploadBox = styled(Box)({
    marginTop: 30,
    height: 200,
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    borderStyle: "dashed",
    borderWidth: "2px",
    borderColor: "divider",
  });

  // use form
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm();
  const { id } = useParams();
  useEffect(() => {
    onReset();
  }, []);
  const onReset = async () => {
    const result = await dispatch(singlePartners(id));
    reset(result.payload);
  };
  // hooks
  const partners = useSelector((state) => state.partners);

  useEffect(() => {
    if (
      partners?.partners?.length !== null &&
      partners?.partners !== undefined
    ) {
      setImageGallery(partners?.partners?.photo);
    }
  }, [partners?.partners]);

  // variable declaration
  const [picture1, setPicture1] = useState(null);
  const [getImg1, setImg1] = useState(null);

  // when image is uploaded
  const onImageUpload1 = (e) => {
    e.persist();
    setPicture1(URL.createObjectURL(e.target.files[0]));
    setImg1(e.target.files[0]);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onSubmit = (data, e) => {
    data.photo = getImg1;
    const formData = new FormData();
    Object?.entries(data).map((entry) => {
      const [key, value] = entry;
      formData.append(key, value);
    });

    dispatch(updatePartners({ formData: formData, id: id }));
    reset();
    setTimeout(function () {
      navigate("/all-partners");
    }, 2000);
  };
  const { t: translate } = useTranslation(["partners"]);
  return (
    <Layout title={"Partners"}>
      <Box sx={{ pt: "80px", pb: "20px" }}>
        <Typography variant="h6" sx={{ marginBottom: "14px" }}>
          {translate("Update Partners Information")}
        </Typography>
        <Paper
          sx={{
            boxShadow: "none !important",
            borderRadius: "12px",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: "divider",
            p: "20px",
            maxWidth: "800px",
            margin: "0 auto",
            cursor: "pointer",
            overflow: "hidden",
          }}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ mt: 2, alignItems: "center" }}>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                {...register(`title`, {
                  required: true,
                })}
              />
            </Box>

            <Box sx={{ mt: 3 }}>
              <TextField
                variant="outlined"
                rows={3}
                fullWidth
                multiline
                {...register(`detail`)}
              />
            </Box>

            <input
              // type="file"
              hidden
              ref={imageInput}
              //onChange={(e) => setImage(e.target.files[0])}
              type="file"
              accept="image/*"
              onChange={onImageUpload1}
            />
            <UploadBox onClick={() => imageInput.current.click()}>
              {getImg1 ? (
                <img
                  src={picture1}
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <img
                  src={`${BaseUrl}${imageGallery}`}
                  alt=""
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              )}
            </UploadBox>

            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: "30px",
              }}
            >
              <Button
                variant="contained"
                sx={{ borderRadius: "5px" }}
                type="submit"
              >
                {translate("Update Partners Info")}
              </Button>
            </Box>
          </form>
        </Paper>
      </Box>
    </Layout>
  );
};

export default UpdatePartners;
